<template>
  <div v-if="editapi">
    <v-dialog max-width="600" v-model="editapi" class="elevation-0 rounded-0" persistent>
      <v-card class="elevation-0 rounded-0" ref="form">
        <v-toolbar class="elevation-0 rounded-0" elevation="0" color="#f7f7f7"  dense >
          <v-toolbar-title v-if="editprofdata.sameUser != true"
            >Edit API access for {{ editprofdata.user.name }}</v-toolbar-title
          >
          <v-toolbar-title v-if="editprofdata.sameUser == true"
            >Edit your API access
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-divider></v-divider>
        <v-container style="margin-top:0"    v-if="!editapidata" fill-height fluid>
        <v-row align="center" justify="center">
          <v-col
            ><img
              alt="Navplus logo"
              width="70px"
              :src="loadernavplus"
              class="justify-center"
          /></v-col>
        </v-row>
      </v-container>
       
        <v-card-text
          v-if="editapidata"
          style="margin-top: 55px; margin-bottom: -50px"
        >
          <div
            class="div"
            style="display: flex; justify-content: space-between"
          >
            <div style="width: 70%">
              <v-text-field
                :value="!keyshow ? null : editapidata.passHash"
                label="API Passphrase / Key"
                outlined
                class="elevation-0 rounded-0"
                readonly
                :append-icon="keyshow ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="keyshow = !keyshow"
              ></v-text-field>
            </div>
            <div style="width: 20%">
              <v-switch
              inset
                style="margin-left: -2em"
                v-model="editapidata.isEnabled"
                :label="editapidata.isEnabled ? 'Enabled' : 'Disabled'"
              ></v-switch>
            </div>
          </div>

          <v-textarea
            :value="editapidata.ip_whitelist"
            label="Allowed IP"
            v-model="editapidata.ip_whitelist"
            hint="Separated by [;] E.g. 127.0.0.1;10.x.x.x;"
            class="elevation-0 rounded-0"
            outlined
          ></v-textarea>

          <v-divider class="mt-12"></v-divider>
        </v-card-text>
        <v-card-actions v-if="editapidata" style="margin-top: 2em">
          <v-btn
          small
          class="elevation-0 rounded-0"
          v-if="editapidata"
            color="primary"
            @click="
              editapidata.isEnable == '' || editapidata.ip_whitelist == ''
                ? (eapi_empty = true)
                : editapidata.isEnable !=  dataapifetch.isEnable ||
                editapidata.ip_whitelist != dataapifetch.ip_whitelist
                ? (eapi_confirm = true)
                : (eapi_nochange = true)
            "
            style="width: 49%"
            dark
          >
            Update Data
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
          small
          class="elevation-0 rounded-0"
            color="red"
            @click="removeEditApi(), (keyshow = null)"
            style="width: 49%"
            dark
          >
            cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="eapi_confirm" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Are you sure? </v-card-title>
        <v-card-text style="text-align: left"
          >Api access data will updated after you click yes</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="eapi_confirm = false">
            No
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="
             PostApiData(),keyshow = null, (dialog = true), (eapi_confirm = false),
             removeEditApi(), (keyshow = null)
            "
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="eapi_nochange" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> No Changes! </v-card-title>
        <v-card-text style="text-align: left"
          >You did not change anything, wanna continue edit or
          leave?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="eapi_nochange = false">
            continue
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="removeEditApi(), (keyshow = null), (eapi_nochange = false)"
          >
            leave
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="eapi_empty" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Empty Input! </v-card-title>
        <v-card-text style="text-align: left"
          >You sending empty field, please write something or
          leave?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="eapi_empty = false">
            continue
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="removeEditApi(), (keyshow = null), (eapi_empty = false)"
          >
            leave
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog" hide-overlay persistent width="300">
      <v-card color="#4CAF50" style="padding: 1em" dark>
        <v-alert dense prominent type="success" style="margin-top: 1em"
          >API data has change</v-alert
        >
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
//   import axios from "axios";
import { mapGetters, mapActions } from "vuex";
export default {
  data: () => ({
    loadernavplus: require("@/assets/img/load100new.gif"),
    dialog: false,
    keyshow: null,
    user: null,
    userpass: null,
    eapi_confirm: null,
      eapi_nochange: null,
      eapi_empty: null,
      editapidata_local:null
  }),

  watch: {
    dialog(val) {
      if (!val) return;

      setTimeout(() => (this.dialog = false), 1000);
    },
  },

  methods: {
    ...mapActions(["fetchApiData", "removeEditApi","postApiData"]),

    PostApiData(){
      const data ={
        id: this.editprofdata.user.id,
        ip_whitelist: this.editapidata.ip_whitelist,
        isEnabled: this.editapidata.isEnabled,
        token:localStorage.getItem("token")
      }
      this.postApiData(data);  
    },

    inputLocal(){
      this.editapidata_local = this.editapidata
    }
  },

  computed: {
    ...mapGetters(["editapidata", "editapi", "editprofdata","dataapifetch"]),
  },
};
</script>

<style lang="scss" scoped></style>
